module.exports = __webpack_public_path__ + "img/certificate03-2-4.d6c8cfb2.jpg";